import { Outlet } from 'react-router-dom';
import { RegistrationCard } from './style/RegistrationCard';
import { RegistrationCardBackgroundWrapper } from './style/RegistrationCardBackgroundWrapper';
import { RegistrationStepContainer } from './style/RegistrationStepContainer';
import {
  getCmsContent,
  buildContentImageLink,
} from 'utils/functions/getCmsContent';

const Registration = () => {
  const { data } = getCmsContent();
  const imageBanner = data?.['banner-large'];

  return (
    <RegistrationCard>
      <RegistrationStepContainer>
        <Outlet />
      </RegistrationStepContainer>
      {imageBanner && (
        <RegistrationCardBackgroundWrapper>
          <img
            src={buildContentImageLink(imageBanner)}
            alt="Registration Banner"
            width={'100%'}
            height={'100%'}
          />
        </RegistrationCardBackgroundWrapper>
      )}
    </RegistrationCard>
  );
};

export default Registration;
